import "./styles.scss";

import { memo } from "react";

import dayjs from "dayjs";
import { CiGlobe } from "react-icons/ci";
import ContactUsLinks from "./ContactUsLinks";
import FooterLinks from "./FooterLinks";
import PolicesLinks from "./PoliciesLinks";
import SocialLinks from "./SocialLinks";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-shell">
        <div className="footer-grid">
          <div>
            <ContactUsLinks />
          </div>
          <div>
            <FooterLinks />
          </div>
          <div>
            <PolicesLinks />
          </div>
          <div>
            <SocialLinks />
          </div>

          <div className="footer-bottom-cell">
            <div className="footer-bottom-wrap">
              <div className="footer-bottom-bar">
                <span className="footer-language">
                  <CiGlobe />
                  English (UK)
                </span>
                <span className="footer-bottom-text">
                  {"\u00A9"} {dayjs().get("year")} Kewordal. All Rights Reserved.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Footer);
